module.exports = __webpack_public_path__ + "img/antes_despues_229.3db8b261.png";